import "antd/es/alert/style";
import _Alert from "antd/es/alert";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useCallback, useReducer } from 'react';
import { IconCheckCircleFilled, IconExclamationCircleFilled, IconCloseCircleFilled, IconInfoCircleFilled, IconCloseOutlined, IconDownOutlined } from '@osui/icons';
import classNames from 'classnames';
import { useBoolean } from '@huse/boolean';
import { useInterval } from '@huse/timeout';
import hoistNonReactStatics from 'hoist-non-react-statics';
import './index.less';
var clsPrefix = 'osui-alert';
var typeToIcon = {
  info: /*#__PURE__*/React.createElement(IconInfoCircleFilled, {
    className: "".concat(clsPrefix, "-infoIcon")
  }),
  success: /*#__PURE__*/React.createElement(IconCheckCircleFilled, {
    className: "".concat(clsPrefix, "-successIcon")
  }),
  error: /*#__PURE__*/React.createElement(IconCloseCircleFilled, {
    className: "".concat(clsPrefix, "-errorIcon")
  }),
  warning: /*#__PURE__*/React.createElement(IconExclamationCircleFilled, {
    className: "".concat(clsPrefix, "-warningIcon")
  })
};

var ActionExpand = function ActionExpand(_ref) {
  var expanded = _ref.expanded,
      open = _ref.open,
      close = _ref.close;
  var handleClick = useCallback(function () {
    if (expanded) {
      close();
    } else {
      open();
    }
  }, [expanded, open, close]);
  return /*#__PURE__*/React.createElement("a", {
    onClick: handleClick,
    className: classNames("".concat(clsPrefix, "-action-expand"), _defineProperty({}, "".concat(clsPrefix, "-action-expand-open"), expanded))
  }, expanded ? '收起' : '展开', " ", /*#__PURE__*/React.createElement(IconDownOutlined, null));
};

var ActionCountDownClose = function ActionCountDownClose(_ref2) {
  var countDown = _ref2.countDown,
      onTimeout = _ref2.onTimeout;

  var _useReducer = useReducer(function (state) {
    return state - 1;
  }, countDown),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      timer = _useReducer2[0],
      reduce = _useReducer2[1]; // 每秒调用一次


  useInterval(reduce, 1 * 1000);

  if (countDown <= 0) {
    return null;
  }

  if (timer === 0) {
    onTimeout();
    return null;
  }

  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(clsPrefix, "-count-down-close")
  }, "(", timer, "s)");
};

var Alert = function Alert(props) {
  var icon = props.icon,
      closeText = props.closeText,
      type = props.type,
      className = props.className,
      closable = props.closable,
      message = props.message,
      actions = props.actions,
      expandable = props.expandable,
      _props$countDown = props.countDown,
      countDown = _props$countDown === void 0 ? -1 : _props$countDown,
      onClose = props.onClose;

  var _useBoolean = useBoolean(false),
      _useBoolean2 = _slicedToArray(_useBoolean, 2),
      expanded = _useBoolean2[0],
      _useBoolean2$ = _useBoolean2[1],
      on = _useBoolean2$.on,
      off = _useBoolean2$.off;

  var _useBoolean3 = useBoolean(false),
      _useBoolean4 = _slicedToArray(_useBoolean3, 2),
      isDestroy = _useBoolean4[0],
      destroy = _useBoolean4[1].on;

  var patchedIcon = icon || typeToIcon[type];
  var patchedClosable = closable === true || countDown > 0;
  var patchedCloseText = patchedClosable ? closeText || /*#__PURE__*/React.createElement(IconCloseOutlined, {
    className: "".concat(clsPrefix, "-icon-cross")
  }) : null;

  var renderActions = function renderActions() {
    var internalActions = actions; // 按顺序添加actions

    if (expandable) {
      internalActions = /*#__PURE__*/React.createElement(React.Fragment, null, internalActions, /*#__PURE__*/React.createElement(ActionExpand, {
        expanded: expanded,
        open: on,
        close: off
      }));
    }

    if (countDown > 0) {
      internalActions = /*#__PURE__*/React.createElement(React.Fragment, null, internalActions, /*#__PURE__*/React.createElement(ActionCountDownClose, {
        countDown: countDown,
        onTimeout: destroy
      }));
    }

    if (internalActions) {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("".concat(clsPrefix, "-message-wrapper"), _defineProperty({}, "".concat(clsPrefix, "-message-wrapper-closable"), closable))
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames("".concat(clsPrefix, "-message-content"), _defineProperty({}, "".concat(clsPrefix, "-message-content-expanded-close"), expandable && !expanded))
      }, message), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-message-actions")
      }, internalActions));
    }

    return null;
  };

  var patchedMessage = renderActions() || message;

  if (isDestroy) {
    // @ts-ignore
    // 这里调用一下onClose但是没有click事件
    onClose && onClose();
    return null;
  }

  return /*#__PURE__*/React.createElement(_Alert, _objectSpread(_objectSpread({}, props), {}, {
    icon: patchedIcon,
    closeText: patchedCloseText,
    className: classNames(clsPrefix, className),
    message: patchedMessage,
    closable: patchedClosable
  }));
};

hoistNonReactStatics(Alert, _Alert);
Alert.ErrorBoundary = _Alert.ErrorBoundary;
export default Alert;
//# sourceMappingURL=index.js.map